import { generatePath } from "react-router";

import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { ContactNew } from "@/components/features-new/contact/new/components";

import { useContactNewPageParams } from "./hooks";

export const ContactNewPage = () => {
	const { hotelID } = useContactNewPageParams();

	return (
		<PageMeta title="新規のお問い合わせ" url={generatePath(PATHS.HOTEL.CONTACT.NEW, { hotelID })}>
			<ContactNew hotelID={hotelID} />
		</PageMeta>
	);
};

ContactNewPage.displayName = "ContactNewPage";
